module.exports = __webpack_public_path__ + "static/Erewhon_pin_hover-7ab58cb0e4334cf40ec29f5a661b21b4.png";